module.exports = __webpack_public_path__ + "static/media/login-background-mobile.db0b9f6a.svg";